import { api } from 'utility';
import {
  getSubscriptionUserUrl,
  getUsageRestrictionsUrl,
  getSubscriptionServiceUrl,
  getToggleDeligationUrl,
  getSubscriptionPaymentUrl,
  getDetaileSubscriptionUserUrl,
  getSubscriptionPermittedProducts,
} from 'URLs';
export function getSubscriptions(params) {
  return api.get(getSubscriptionUserUrl(), { params }).then((res) => res.data);
}

export function getUsageRestrictions(data, params) {
  return api.post(getUsageRestrictionsUrl(), data, { params }).then((res) => res.data);
}

export function getConsumers(params) {
  return api.get(getSubscriptionServiceUrl(), { params }).then((res) => res.data);
}

export function changeDelegationStatus(id, newStatus) {
  return newStatus
    ? api.post(getToggleDeligationUrl(id)).then((res) => res.data)
    : api.delete(getToggleDeligationUrl(id)).then((res) => res.data);
}

export function subscriptionPayment(id) {
  return api.post(getSubscriptionPaymentUrl(id)).then((res) => res.data);
}
// اطلاعات پایه سرویس های فعال
export function getSubscriptionById(id, params) {
  return api.get(getDetaileSubscriptionUserUrl(id), { params }).then((res) => res.data);
}
// لیست محصولات
export function getSubscriptionPlan(id, params) {
  return api.get(getSubscriptionPermittedProducts(id), { params }).then((res) => res.data);
}

export default {
  getSubscriptions,
  getUsageRestrictions,
  getConsumers,
  changeDelegationStatus,
  subscriptionPayment,
  getSubscriptionById,
  getSubscriptionPlan,
};
